import React, { useMemo } from "react";
import { Box, Chip } from "@tiny/components";
import { PredefinedSegmentsProvider } from "./PredefinedSegments.context";
import { SegmentsSectionProps } from "./PredefinedSegments.types";
import { SectionHeader } from "./SectionHeader";
import { SegmentCards } from "./SegmentCards";

export function DeliverySegmentsSection({
  segments,
  selected,
  selectionDisabled,
  onSegmentSelect,
}: SegmentsSectionProps) {
  const context = useMemo(
    () => ({
      isDisabled: false,
      isRecommended: false,
    }),
    []
  );

  return (
    <PredefinedSegmentsProvider value={context}>
      <Box id="recommendedSegmentsSection" mt={{ xs: 7, md: 6 }}>
        <SectionHeader
          id="recommendedSegmentsSection_Header"
          title={
            <>
              Delivery Segment&nbsp;&nbsp;&nbsp;
              <Chip
                label="New Launch"
                style={{
                  backgroundColor: "#3BB700", // TODO: in v2 use the system colors
                  color: "white",
                }}
                size="medium"
              />
            </>
          }
          subtitle="Use predefined delivery segments to better drive emails into your customers' inboxes."
        />
        <SegmentCards
          id="recommendedSegmentsSection_Content"
          cards={segments}
          selected={selected}
          onSegmentSelect={onSegmentSelect}
          selectionDisabled={selectionDisabled}
        />
      </Box>
    </PredefinedSegmentsProvider>
  );
}
